const vistasConfig = {};
/**
 * Configuración default de campaña de módulo
 * Será mergeada con deepmerge con campaña específica
 */
export default {
  googleAnalyticsId: null,
  modulo: "Contacto",
  vistas: vistasConfig
};
